import { isNil, isObject } from "lodash/fp";

class Controller {
  constructor(
    $injector,
    ContractorTransforms,
    $stateParams,
    Contractor,
    Sections,
    Lists
  ) {
    "ngInject";

    this.lists = Lists.all;
    this.Events = $injector.get("Events");
    this.Contractor = $injector.get("Contractor");
    this.ContractorTransforms = ContractorTransforms;
    this.contractorResourceId = $stateParams.id;
    this.Contractor = Contractor;
    this.sections = Sections.fleetSections;

    this.Captain = $injector.get("Captain");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.onUpdateExtraInfoEvent = this.Events.getUpdateEvent("extraInfo");
    this.successUpdateExtraInfoEvent = this.Events.successUpdateEvent(
      "extraInfo"
    );
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.addItemEvent = this.Events.getAddEvent("contractorCaptain");
    this.addOptions = this.ContractorTransforms.addOptions;
    this.onUpdateEvent = this.Events.getUpdateEvent("contractor");

    this.captainFields = this.ContractorTransforms.captainFields;
    this.captainParams = {
      contractor: this.contractorResourceId,
      isCityRequired: false,
    };

    this.invoiceFields = this.ContractorTransforms.invoiceFields;
    this.invoiceParams = {
      contractor: this.contractorResourceId,
      isCityRequired: false,
    };

    this.contractorDocumentsMetadata = [
      { title: "National ID", key: "national_id", holder: "owner" },
      {
        title: "Commercial Registration",
        key: "commercial_registration",
        holder: "documents",
      },
      {
        title: "Insurance Number",
        key: "insurance_number",
        holder: "documents",
      },
      { title: "Tax Number", key: "tax_number", holder: "documents" },
    ];

    this.addManager = this.addManager.bind(this);
    this.deleteManager = this.deleteManager.bind(this);
  }

  $onInit() {
    this.getContractor();

    this.Events.on(
      this.onUpdateExtraInfoEvent,
      this.onUpdateExtraInfo.bind(this)
    );
    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
  }

  $onDestroy() {
    this.Events.off(this.onUpdateExtraInfoEvent, this.onUpdateExtraInfo);
    this.Events.off(this.onUpdateEvent, this.onUpdate);
  }

  getContractor() {
    this.Contractor.get(this.contractorResourceId)
      .$promise.then((response) => {
        this.contractor = this.ContractorTransforms.justify(response);
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  onUpdate(item) {
    if (!isNil(item.key)) {
      let value = isNil(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;
      const { extraParams } = item;
      let updatedItem;
      if (item.value === "true") value = true;
      if (item.value === "false") value = false;
      if (isNil(extraParams)) {
        updatedItem = {
          [item.key]: value,
        };
      } else {
        updatedItem = {
          [extraParams]: {
            [item.key]: value,
          },
        };
      }
      this.Contractor.update(
        this.contractorResourceId,
        updatedItem
      ).$promise.then(
        (response) => {
          this.contractor = this.ContractorTransforms.justify(response);
          this.Events.emit(this.successNotificationEvent, {
            message: `"${this.formatKey(
              item.key
            )}" has been updated successfully`,
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    }
  }

  onUpdateExtraInfo(options) {
    this.onUpdate({
      key: "extra_info",
      value: options.info,
    });
  }

  formatKey(key) {
    return key
      .split("_")
      .map((word) => `${word[0].toUpperCase()}${word.slice(1)}`)
      .join(" ");
  }

  constructItem(name, model) {
    const item = {
      key: name,
      value: this.sanitizeRequest(model),
    };

    this.onUpdate(item);
  }

  sanitizeRequest(obj) {
    if (!isObject(obj)) return obj;
    delete obj.key;
    delete obj.isDisabled;
    return Object.keys(obj).reduce((sanitizedObj, key) => {
      if (!isNil(obj[key])) sanitizedObj[key] = obj[key];
      return sanitizedObj;
    }, {});
  }

  addManager({ name: managerName, _id: managerId }) {
    this.Contractor.addManagers(this.contractorResourceId, {
      managers: [managerId],
    })
      .$promise.then(() => {
        this.getContractor();
        this.Events.emit(this.successNotificationEvent, {
          message: `${managerName} is added successfully`,
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  deleteManager({ name: managerName, _id: managerId }) {
    this.Contractor.deleteManagers(this.contractorResourceId, {
      managers: [managerId],
    })
      .$promise.then(() => {
        this.getContractor();
        this.Events.emit(this.successNotificationEvent, {
          message: `${managerName} is removed successfully`,
        });
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/contractor/contractor.controller.js